PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX body: <http://purl.obolibrary.org/obo/UBERON_0013702>
PREFIX hasExactSynonym: <http://www.geneontology.org/formats/oboInOwl#hasExactSynonym>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT DISTINCT ?root ?child ?parent ?label ?synonymLabel
FROM HRA:
WHERE {
  BIND(body: as ?root)

  {
    BIND(body: as ?child)
  }
  UNION
  {
    # Prioritize ASCT+B relationships from the anatomical-systems table
    SELECT (1 as ?rank) ?parent ?child
    WHERE {
      GRAPH <https://purl.humanatlas.io/asct-b/anatomical-systems> {
        ?child ccf:ccf_part_of ?parent .
      }
    }
  }
  UNION {
    VALUES (?parent ?child) {
      # Lymph Node
      (<http://purl.obolibrary.org/obo/UBERON_0000029> <http://purl.obolibrary.org/obo/UBERON_0002509>)
      # Eye
      (<http://purl.obolibrary.org/obo/UBERON_0000970> <http://purl.obolibrary.org/obo/UBERON_0004548>)
      (<http://purl.obolibrary.org/obo/UBERON_0000970> <http://purl.obolibrary.org/obo/UBERON_0004549>)
      # Fallopian Tube
      (<http://purl.obolibrary.org/obo/UBERON_0003889> <http://purl.obolibrary.org/obo/UBERON_0001303>)
      (<http://purl.obolibrary.org/obo/UBERON_0003889> <http://purl.obolibrary.org/obo/UBERON_0001302>)
      # Kidney
      (<http://purl.obolibrary.org/obo/UBERON_0002113> <http://purl.obolibrary.org/obo/UBERON_0004538>)
      (<http://purl.obolibrary.org/obo/UBERON_0002113> <http://purl.obolibrary.org/obo/UBERON_0004539>)
      # Knee
      (<http://purl.obolibrary.org/obo/UBERON_0001465> <http://purl.org/sig/ont/fma/fma24978>)
      (<http://purl.obolibrary.org/obo/UBERON_0001465> <http://purl.org/sig/ont/fma/fma24977>)
      # Mammary Gland
      (<http://purl.obolibrary.org/obo/UBERON_0001911> <http://purl.org/sig/ont/fma/fma57991>)
      (<http://purl.obolibrary.org/obo/UBERON_0001911> <http://purl.org/sig/ont/fma/fma57987>)
      # Ovary
      (<http://purl.obolibrary.org/obo/UBERON_0000992> <http://purl.obolibrary.org/obo/UBERON_0002119>)
      (<http://purl.obolibrary.org/obo/UBERON_0000992> <http://purl.obolibrary.org/obo/UBERON_0002118>)
      # Palatine Tonsil
      (<http://purl.obolibrary.org/obo/UBERON_0002373> <http://purl.org/sig/ont/fma/fma54974>)
      (<http://purl.obolibrary.org/obo/UBERON_0002373> <http://purl.org/sig/ont/fma/fma54973>)
      # Renal Pelvis
      (<http://purl.obolibrary.org/obo/UBERON_0001224> <http://purl.obolibrary.org/obo/UBERON_0018116>)
      (<http://purl.obolibrary.org/obo/UBERON_0001224> <http://purl.obolibrary.org/obo/UBERON_0018115>)
      # Ureter
      (<http://purl.obolibrary.org/obo/UBERON_0000056> <http://purl.obolibrary.org/obo/UBERON_0001223>)
      (<http://purl.obolibrary.org/obo/UBERON_0000056> <http://purl.obolibrary.org/obo/UBERON_0001222>)
    }
  }
  UNION
  {
    ?child ccf:ccf_part_of ?parent .
    FILTER(?parent != body:)
  }
  
  ?child ccf:ccf_pref_label ?label1 .
  OPTIONAL {
    {
      ?child hasExactSynonym: ?synonymLabel1 .
    }
    UNION
    {
      ?child rdfs:label ?synonymLabel1 .
    }
  }

  BIND(IF(?child = ?root, 'body', STR(LCASE(?label1))) as ?label)
  BIND(STR(?synonymLabel1) as ?synonymLabel)
  BIND(IF(BOUND(?rank), ?rank, 1000) as ?rank_order)
}
ORDER BY ?rank_order ?label ?child
